export default "__VITE_ASSET__DxSBfvrH__"